import { FunctionComponent } from 'react'

import styled, { css, useTheme } from 'styled-components'

import { SocialItemType } from '@widgets/AuthorHeadline/types'
import Blink from '@components/Blink'
import SvgIcon from '@components/SvgIcon'

interface SocialItemProps {
  type: SocialItemType
  src?: string
}

const StyledBlink = styled(Blink)`
  ${({
    theme: {
      colors: { fillStrong, fillStrongHover },
    },
  }) => {
    return css`
      display: flex;
      justify-content: center;
      align-items: center;
      width: 36px;
      height: 36px;
      border-radius: 64px;
      cursor: pointer;
      background-color: ${fillStrong};
      appearance: none;
      -webkit-appearance: none;
      -moz-appearance: none;
      user-select: none;

      &:hover {
        background-color: ${fillStrongHover};
      }
    `
  }}
`

const additionalStyles = css`
  width: 28px;
`

const SocialItem: FunctionComponent<SocialItemProps> = ({ type, src }) => {
  const theme = useTheme()
  const iconColor = theme.colors.iconDefault

  if (!src) {
    return null
  }

  const preparedLink = `${type === 'mail' ? 'mailto:' : ''}${src}`

  const linkProps = {
    href: preparedLink,
    target: '_blank',
    rel: 'nofollow noopener',
  }

  return (
    <StyledBlink {...linkProps}>
      <SvgIcon
        iconName={`${type}-plain`}
        size={20}
        color={iconColor}
        additionalStyles={additionalStyles}
      />
    </StyledBlink>
  )
}

export default SocialItem
